import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { PROJECTS } from "@/data/content";

export default function Projects() {
  return (
    <div data-testid="projects-page">
      <PageHero
        overline="Projects & Portfolio"
        lines={["Farms We've Helped", "Build & Grow"]}
        subtitle="Real systems, real yields. A look at the farms we've designed, built, and managed across India."
        testId="projects-hero"
      />

      <section className="border-b border-border">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-16 md:py-24 grid grid-cols-1 md:grid-cols-2 gap-px bg-border border border-border">
          {PROJECTS.map((p, i) => (
            <Reveal key={p.name} delay={(i % 2) * 0.1} className="bg-background">
              <article
                data-testid={`project-card-${i}`}
                className="group h-full flex flex-col"
              >
                <div className="relative overflow-hidden aspect-[16/10]">
                  <img
                    src={p.image}
                    alt={p.name}
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background/60 to-transparent" />
                  <span className="absolute top-5 left-5 overline bg-primary text-primary-foreground px-3 py-1.5">
                    {p.system}
                  </span>
                </div>
                <div className="p-8 flex-1 flex flex-col">
                  <div className="flex items-center gap-2 text-muted-foreground text-sm">
                    <MapPin className="w-4 h-4 text-primary" />
                    {p.location}
                  </div>
                  <h3 className="mt-3 font-clash text-2xl md:text-3xl">{p.name}</h3>
                  <div className="mt-6 grid grid-cols-2 gap-y-4 border-t border-border pt-6">
                    <div>
                      <div className="overline text-muted-foreground">Crop</div>
                      <div className="mt-1">{p.crop}</div>
                    </div>
                    <div>
                      <div className="overline text-muted-foreground">Area</div>
                      <div className="mt-1">{p.area}</div>
                    </div>
                  </div>
                  <div className="mt-6 pt-6 border-t border-border">
                    <div className="overline text-primary">Result</div>
                    <p className="mt-2 font-clash text-lg">{p.result}</p>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-32">
        <Reveal>
          <h2 className="font-clash text-3xl md:text-5xl tracking-tight max-w-3xl">
            Your land could be our next success story.
          </h2>
          <Link
            to="/contact"
            data-testid="projects-cta"
            className="group mt-10 overline inline-flex items-center gap-3 bg-primary text-primary-foreground px-8 py-4 font-bold transition-transform duration-300 hover:scale-[1.04]"
          >
            Get a Free Site Assessment
            <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
